import React from 'react';
import { motion } from 'framer-motion';
import { CodeIcon, CheckCircleIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function IntegrationSlide() {
  return <SlideLayout data-id="element-251">
      <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-252">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-253">
          Drop-In Replacement.{' '}
          <span className="text-brand-teal" data-id="element-254">One API Key Swap.</span>
        </h2>
        <p className="text-xl text-brand-text-dim" data-id="element-255">
          The simplicity of the code IS the message.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-256">
        {/* Before Code */}
        <motion.div variants={itemVariants} className="rounded-xl overflow-hidden border border-brand-border shadow-2xl" data-id="element-257">
          <div className="bg-[#161b22] px-4 py-2 border-b border-brand-border flex items-center gap-2" data-id="element-258">
            <div className="flex gap-1.5" data-id="element-259">
              <div className="w-3 h-3 rounded-full bg-red-500/20 border border-red-500/50" data-id="element-260" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/20 border border-yellow-500/50" data-id="element-261" />
              <div className="w-3 h-3 rounded-full bg-green-500/20 border border-green-500/50" data-id="element-262" />
            </div>
            <span className="text-xs text-brand-text-muted ml-2 font-mono" data-id="element-263">
              Before (OpenAI)
            </span>
          </div>
          <div className="bg-[#0d1117] p-6 text-sm font-mono overflow-x-auto" data-id="element-264">
            <pre className="text-brand-text-dim" data-id="element-265">
              <code data-id="element-266">
                <span className="text-pink-400" data-id="element-267">import</span> openai{'\n\n'}
                client <span className="text-pink-400" data-id="element-268">=</span> openai.OpenAI(
                {'\n'}
                {'  '}api_key<span className="text-pink-400" data-id="element-269">=</span>
                <span className="text-green-400" data-id="element-270">"sk-proj-..."</span>,{'\n'})
                {'\n\n'}
                response <span className="text-pink-400" data-id="element-271">=</span>{' '}
                client.chat.completions.create({'\n'}
                {'  '}model<span className="text-pink-400" data-id="element-272">=</span>
                <span className="text-green-400" data-id="element-273">"gpt-4"</span>,{'\n'}
                {'  '}messages<span className="text-pink-400" data-id="element-274">=</span>[{'\n'}
                {'    '}
                {'{'} <span className="text-green-400" data-id="element-275">"role"</span>:{' '}
                <span className="text-green-400" data-id="element-276">"user"</span>,{' '}
                <span className="text-green-400" data-id="element-277">"content"</span>:{' '}
                <span className="text-green-400" data-id="element-278">"Hello"</span> {'}'}
                {'\n'}
                {'  '}]{'\n'})
              </code>
            </pre>
          </div>
        </motion.div>

        {/* After Code */}
        <motion.div variants={itemVariants} className="rounded-xl overflow-hidden border border-brand-teal shadow-[0_0_30px_rgba(0,212,170,0.15)] relative" data-id="element-279">
          <div className="bg-[#161b22] px-4 py-2 border-b border-brand-border flex items-center gap-2" data-id="element-280">
            <div className="flex gap-1.5" data-id="element-281">
              <div className="w-3 h-3 rounded-full bg-red-500/20 border border-red-500/50" data-id="element-282" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/20 border border-yellow-500/50" data-id="element-283" />
              <div className="w-3 h-3 rounded-full bg-green-500/20 border border-green-500/50" data-id="element-284" />
            </div>
            <span className="text-xs text-brand-teal ml-2 font-mono" data-id="element-285">
              After (OpenFPGA)
            </span>
          </div>
          <div className="bg-[#0d1117] p-6 text-sm font-mono overflow-x-auto relative" data-id="element-286">
            <pre className="text-brand-text-dim" data-id="element-287">
              <code data-id="element-288">
                <span className="text-pink-400" data-id="element-289">import</span> openai{'\n\n'}
                client <span className="text-pink-400" data-id="element-290">=</span> openai.OpenAI(
                {'\n'}
                <div className="bg-brand-teal/20 -mx-6 px-6 py-0.5 border-l-2 border-brand-teal" data-id="element-291">
                  {'  '}base_url<span className="text-pink-400" data-id="element-292">=</span>
                  <span className="text-green-400" data-id="element-293">
                    "https://api.openfpga.ai/v1"
                  </span>
                  ,
                </div>
                <div className="bg-brand-teal/20 -mx-6 px-6 py-0.5 border-l-2 border-brand-teal" data-id="element-294">
                  {'  '}api_key<span className="text-pink-400" data-id="element-295">=</span>
                  <span className="text-green-400" data-id="element-296">"ofpga_sk_live_..."</span>,
                </div>
                ){'\n\n'}
                response <span className="text-pink-400" data-id="element-297">=</span>{' '}
                client.chat.completions.create({'\n'}
                <div className="bg-brand-teal/20 -mx-6 px-6 py-0.5 border-l-2 border-brand-teal" data-id="element-298">
                  {'  '}model<span className="text-pink-400" data-id="element-299">=</span>
                  <span className="text-green-400" data-id="element-300">"llama-3.1-8b-fpga"</span>,
                </div>
                {'  '}messages<span className="text-pink-400" data-id="element-301">=</span>[{'\n'}
                {'    '}
                {'{'} <span className="text-green-400" data-id="element-302">"role"</span>:{' '}
                <span className="text-green-400" data-id="element-303">"user"</span>,{' '}
                <span className="text-green-400" data-id="element-304">"content"</span>:{' '}
                <span className="text-green-400" data-id="element-305">"Hello"</span> {'}'}
                {'\n'}
                {'  '}]{'\n'})
              </code>
            </pre>
          </div>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-306">
        <div className="flex items-start gap-3" data-id="element-307">
          <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-308" />
          <p className="text-sm text-brand-text-dim" data-id="element-309">
            Standard REST API. Works with any HTTP client. Python & TS SDKs
            available.
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-310">
          <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-311" />
          <p className="text-sm text-brand-text-dim" data-id="element-312">
            Zero FPGA expertise needed. No hardware provisioning or firmware
            updates.
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-313">
          <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-314" />
          <p className="text-sm text-brand-text-dim" data-id="element-315">
            Sign up → receive API key → start sending requests immediately.
          </p>
        </div>
      </motion.div>
    </SlideLayout>;
}